// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".validation_867a {\n  font-size: 0.8125rem;\n}\n\n.table-row_5eb3 {\n  vertical-align: top;\n}", "",{"version":3,"sources":["/home/runner/work/telemetry/telemetry/ts/packages/frontend/src/component/Settings/Integrations/WebhooksRow.scss","WebhooksRow.scss"],"names":[],"mappings":"AAEA;EACI,oBAAA;ACDJ;;ADIA;EACI,mBAAA;ACDJ","file":"WebhooksRow.scss","sourcesContent":["@import \"@formant/ui/style/common\";\n\n.validation {\n    font-size: 0.8125rem;\n}\n\n.table-row {\n    vertical-align: top;\n}\n",".validation {\n  font-size: 0.8125rem;\n}\n\n.table-row {\n  vertical-align: top;\n}"]}]);
// Exports
exports.locals = {
	"validation": "validation_867a",
	"table-row": "table-row_5eb3"
};
module.exports = exports;
